const inputs = {
  document: {
    id: 'document',
    name: 'document',
    label: 'documentationList.form.document.label',
  },
}

export default inputs;
